import { action } from "mobx";
import { comm } from "../../comm";
import { Account } from "./Account";

export class GuestAccount extends Account{

	@action.bound changeSIUAccount(siuId){
		this.localData.id = siuId;
		return this.login(siuId, localStorage.getItem('acceptedTosId'));
	}

	@action.bound login(siuId,tosId){
		//guest always attempts to log in even if there is no data.
		//server will respond with new account
		return comm.Login(this.abv,tosId,siuId,this.localData.id)
		.then((response) => {
			this.serverData = response.Payload;

			this.localData.id = this.serverData.AnonymousUsername;
			this.applyToLocalStorage();

			return this.serverData;
		})
	}
}